var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrapingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_39_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 12.9075C33 8.73965 33 6.65531 32.1887 5.0634C31.4756 3.66312 30.3369 2.52436 28.9366 1.81126C27.3447 0.999992 25.2611 1 21.0933 1H12.9067C8.73887 1 6.65532 0.999992 5.06341 1.81126C3.66313 2.52436 2.52437 3.66312 1.81127 5.0634C0.999998 6.65531 1 8.73965 1 12.9075V21.0933C1 25.2611 0.999998 27.3447 1.81127 28.9366C2.52437 30.3369 3.66313 31.4756 5.06341 32.1895C6.65532 33 8.73887 33 12.9067 33H21.0933C25.2611 33 27.3447 33 28.9366 32.1895C30.3369 31.4756 31.4756 30.3369 32.1887 28.9366C33 27.3447 33 25.2611 33 21.0933V12.9075Z",
    fill: "url(#paint0_linear_39_119)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddi_39_119)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17 27.7586C22.7677 27.7586 27.4433 23.083 27.4433 17.3153C27.4433 11.5476 22.7677 6.87195 17 6.87195C11.2323 6.87195 6.55664 11.5476 6.55664 17.3153C6.55664 23.083 11.2323 27.7586 17 27.7586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4233 14.6495C13.2277 12.4729 11.5491 10.4447 10.7343 9.70265L10.2842 9.31767C12.0998 7.79135 14.4427 6.87195 17.0004 6.87195C19.3118 6.87195 21.448 7.62293 23.178 8.89422C23.4224 9.63625 22.9568 11.1867 22.468 11.9287C22.2909 12.1975 21.8893 12.5312 21.449 12.8475C20.4564 13.5607 19.2037 13.9134 18.5669 15.2266C18.3847 15.6021 18.3926 15.9689 18.4801 16.288C18.5431 16.5172 18.5833 16.7665 18.5839 17.0104C18.586 17.7987 17.7886 18.3682 17.0004 18.3596C14.949 18.3373 13.6061 16.684 13.4233 14.6495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5003 23.8696C19.5322 21.925 22.9718 21.925 22.9718 21.925C26.556 21.8876 27.0401 19.7114 27.3638 18.6115C26.7845 23.2916 23.1088 27.0118 18.4502 27.659C18.1133 26.9499 17.7141 25.351 18.5003 23.8696Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_39_119",
    x: 0.369458,
    y: 0.684729,
    width: 33.2611,
    height: 33.4187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.472906
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.315271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.157635
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.157635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_39_119",
    result: "effect2_dropShadow_39_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_39_119",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.315271
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.315271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.643137 0 0 0 0 0.937255 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_39_119"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddi_39_119",
    x: 3.83748,
    y: 4.46799,
    width: 26.325,
    height: 26.4827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.472906
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.315271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.157635
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.157635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_39_119",
    result: "effect2_dropShadow_39_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_39_119",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.315271
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.315271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.643137 0 0 0 0 0.937255 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_39_119"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_119",
    x1: 23.6975,
    y1: 2.8605,
    x2: 16.0701,
    y2: 29.8374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252D3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#483E57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrapingIcon);
export default __webpack_public_path__ + "static/media/scraping-icon.be8bcf4538301ac088d6f78835574c99.svg";
export { ForwardRef as ReactComponent };